module.exports = __webpack_public_path__ + "static/media/playstation.76520e57.svg";